

      <template>
  <div class="col-xs-12">
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="!(errorMessage == ''|| errorMessage == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{errorMessage}}</strong>
        </div>
        <div v-else>
          <h3>Commissions</h3>
          <div class="form-group form-inline custom-width">
            <div class="pull-right">
              <button class="btn btn-primary">Add Commission</button>
            </div>
          </div>
          <br>
          <div v-bind:id="'printable'">
            <strong v-currentdate></strong>
            <table class="table table-bordered ng-grid">
              <thead style="background:#efeeed;">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('CommodityName')">Commodity</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='CommodityName'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Commission')">Commission</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='Commission'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>

                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('CurrencyName')">Currency</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='CurrencyName'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('CurrencyName')">Uploaded By</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='CurrencyName'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option,index) in OrderBy"
                  :key="index"
                  :class="{'even':(index+1 %2==0)}"
                >
                  <td>{{index + 1}}</td>
                  <td>{{option.CommodityName}}</td>
                  <td>{{option.Commission}}</td>
                  <td>{{option.CurrencyName}}</td>
                  <td>{{option.CreatedBy}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
//import VeeValidate, { Validator } from "vee-validate";
import { mapFields } from "vee-validate";
// import commissionadd from "./CommissionAdd";
export default {
  data() {
    return {
      ERROR_MESSAGE: "",
      SelectedPageSize: 10,
      currentPage: 1,
      showModal: false,
      UserId: null,
      Search: null,
      currentSort: "Name",
      curentSortOrder: "asc"
    };
  },
  methods: {
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function(page) {
      if (page) {
        this.currentPage = page;
        this.ChnageUrl();
        this.GetData();
      }
    },
    ChnageUrl() {
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort;
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },
    CloseModal() {
      this.$emit("Close");
    },
    saveCommission() {},
    GetData() {
      var vm = this;
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search);
      this.$store
        .dispatch(ACTIONS.COMMISSIONS_GET, Url)
        .then(res => {})
        .catch(err => {});
    }
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
    }

    this.GetData();
  },
  computed: {
    ...mapGetters({
      loading: "COMMITIONLOADING",
      Commission: "GETCOMMITION",
      // Banks: "GETCOMMITIONBANKS",
      errorMessage: "COMMITIONERROR"
    }),
    OrderBy() {
      var data = [...this.Commission];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      return SortedArray;
    }
  }
};
</script>